if (window.hideTabPanelsInitialized === undefined) {
  window.hideTabPanelsInitialized = true;

  const showPanel = input => {
    const tab = input.nextElementSibling;
    const tabsBlock = tab.closest('.js-tabs-tabs');
    const panelContainer = tabsBlock.querySelector('.js-tabs-panel-container');

    const panels = Array.from(
      panelContainer.querySelectorAll('.js-tabs-panel'),
    );

    for (const panel of panels) {
      panel.classList.add('hidden');
    }

    panelContainer
      .querySelector(`div[data-tab="${CSS.escape(tab.dataset.tab)}"]`)
      .classList.remove('hidden');
  };

  const allInputs = Array.from(
    document.querySelectorAll('.c-tabs-tab > input'),
  );

  for (const input of allInputs) {
    input.addEventListener('change', () => showPanel(input), false);
    if (input.checked) {
      showPanel(input);
    }
  }
}
